import { getFlagValue } from "../../utils/ab_tests"
import { isMobile } from "../../utils/breakpoints"
import { displayAd } from "./display"
import { initializeAd } from "./initialize"
import { googletag } from "./shared"
import { adStatuses, getOrCreateStatus } from "./status"

const alongslideAdKeys = [
  "alongslideDesktop1",
  "alongslideDesktop2",
  "alongslideDesktop3",
  "alongslideDesktop4",
  "alongslideDesktop5",
  "alongslideDesktop6",
  "alongslideDesktop7",
  "alongslideDesktop8",
  "alongslideDesktop9",
  "alongslideDesktop10",
  "alongslideMobile1",
  "alongslideMobile2",
  "alongslideMobile3",
  "alongslideMobile4",
  "alongslideMobile5",
  "alongslideMobile6",
  "alongslideMobile7",
  "alongslideMobile8",
  "alongslideMobile9",
  "alongslideMobile10",
]

const SWAP_EVERY_X_SLIDES = 4

const hideAndClearAd = (status) => {
  if (!status || !status.slot) {
    return
  }
  const { slot } = status
  const currentSlotId = slot.getSlotElementId()
  document.getElementById(`${currentSlotId}-container`).classList.add("hidden")
  googletag.destroySlots([slot])
  status.initialized = false
  status.filled = false
}

const clearAlongslideAds = () => {
  alongslideAdKeys.forEach((key) => {
    hideAndClearAd(adStatuses[key])
  })
}

const showAlongslideAd = (nextAdIndex) => {
  const containerString = isMobile()
    ? `Slideshow_Page_Alongside_Preso_Mobile_${nextAdIndex}`
    : `Slideshow_Page_Alongside_Preso_Desktop_${nextAdIndex}`
  const key = `alongslide${isMobile() ? "Mobile" : "Desktop"}${nextAdIndex}`
  const containerId = `alongslide-player-${isMobile() ? "mobile" : "desktop"}-ad-${nextAdIndex}-container`
  const container = document.getElementById(containerId)

  const status = getOrCreateStatus(key)
  status.activePath = containerString
  if (container) {
    container.classList.remove("hidden")
  }
  initializeAd(key)
  displayAd(key)
}

const getAlongslideAdIndex = (navigationCount) => {
  const quotient = Math.floor(navigationCount / SWAP_EVERY_X_SLIDES)
  // Take the ones column, to ensure the value is 0-9
  const onesValue = parseInt([...quotient.toString()].reverse()[0], 10)
  // Make the value between 1-10
  return onesValue + 1
}

export const swapAlongslideAdContainer = async (navigationCount) => {
  const isFeatureFlagActive = await getFlagValue("alongslide_ads_flag")
  if (!isFeatureFlagActive) {
    return
  }
  const shouldSwap = navigationCount % SWAP_EVERY_X_SLIDES === 0
  if (shouldSwap) {
    const nextAdIndex = getAlongslideAdIndex(navigationCount)
    clearAlongslideAds()
    showAlongslideAd(nextAdIndex)
  }
}
